import { render, staticRenderFns } from "./PlatformElderIncreaseTendency.vue?vue&type=template&id=2a00df71&scoped=true&"
import script from "./PlatformElderIncreaseTendency.vue?vue&type=script&lang=js&"
export * from "./PlatformElderIncreaseTendency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a00df71",
  null
  
)

export default component.exports